<template>
  <v-main>
    <GlobalCameraHistoryDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      @rowClicked="showRowDetails"
    />
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import GlobalCameraHistoryDialog from './GlobalCameraHistoryDialog.vue'

export default {
  pageTitle: 'Histórico de Câmeras',
  components: {
    GenericReport,
    GlobalCameraHistoryDialog
  },
  data() {
    return {
      reportSpec: {
        code: 'globalCameraHistory',
        title: 'Histórico de Câmeras',
        apiBase: '/cameras/history',
        filters: [
          'DateRange',
          { type: 'Technician', showInMenu: true, whenEmpty: '(Todos)' },
          {
            type: 'CostCenter',
            showInMenu: true,
            whenEmpty: '(Todos)',
            emptyMeansAll: true
          },
          { type: 'Vehicle', whenEmpty: '(Todos)', showInMenu: true },
          {
            type: 'Switch',
            label: 'Mostrar registros removidos',
            prefix: 'includeInactive',
            showInMenu: true,
            defVal: false
          }
        ]
      }
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
